import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import Home from '@/views/Home'
import Story from '@/views/Story'
import ShadowSide from '@/views/ShadowSide'
import ShineSide from '@/views/ShineSide'
import Class from '@/views/Class'
import Tower from '@/views/Tower'
import Ranking from '@/views/Ranking'
import Skill from '@/views/Skill'

Vue.use(Router)

const router =  new Router({
    //hashbang: false,
    //mode : 'history',
   // base: process.env.NODE_ENV === 'production'?   '/classic/update/history/2019/190220_jinkamael/' : process.env.BASE_URL,
    routes: [
      {
        path: '/home',
        name: 'home',
        component: Home
      },
      {
          path: '/story',
          name: 'story',
          component: Story
      },
      {
        path: '/shadowSide',
        name: 'shadowSide',
        component: ShadowSide
      },
      {
          path: '/shineSide',
          name: 'shineSide',
          component: ShineSide
      },
      {
          path: '/class',
          name: 'class',
          component: Class
      },
      {
          path: '/tower',
          name: 'tower',
          component: Tower
      },
      {
          path: '/ranking',
          name: 'ranking',
          component: Ranking
      },
      {
          path: '/skill',
          name: 'skill',
          component: Skill
      },
    { path: '*', component: Home }
  ]
})

router.beforeEach((to, from, next) => {
  if(store.state.isMovePage)return;
  if(store.state.isLayerView)return;
  next();
})

export default router
